import Swiper from "swiper/bundle";
import "swiper/css/bundle";

const offerSlider = new Swiper(".offer-slider", {
  slidesPerView: 1,
  spaceBetween: 20,
  autoHeight: true,

  navigation: {
    prevEl: "#offer .prev",
    nextEl: "#offer .next",
  },
  loop: true,
  // autoHeight: true,
});

export function updateOfferSlider() {
  offerSlider.update();
}
